var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaysLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(-636 -545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "day-cloudy",
    transform: "translate(637 548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M0,11.085a3.43,3.43,0,0,0,1.7,2.979,3.347,3.347,0,0,0,1.715.458h7.5a3.426,3.426,0,0,0,3.437-3.437A3.547,3.547,0,0,0,14.067,9.7a3.508,3.508,0,0,0,.793-2.294,3.575,3.575,0,0,0-.286-1.413,3.554,3.554,0,0,0-1.933-1.933,3.61,3.61,0,0,0-4.1.923,3.742,3.742,0,0,0-1.871-.455A4.116,4.116,0,0,0,2.638,7.758a3.3,3.3,0,0,0-1.9,1.2A3.333,3.333,0,0,0,0,11.085Zm1.183,0a2.138,2.138,0,0,1,.582-1.5A2.286,2.286,0,0,1,3.223,8.85l.344-.019q.13,0,.13-.123l.045-.377a2.973,2.973,0,0,1,.975-1.881,2.8,2.8,0,0,1,1.949-.757,2.887,2.887,0,0,1,1.991.76A2.789,2.789,0,0,1,9.61,8.33l.052.4A.134.134,0,0,0,9.8,8.85h1.118a2.263,2.263,0,0,1,2.242,2.235,2.2,2.2,0,0,1-.659,1.608,2.147,2.147,0,0,1-1.582.666h-7.5a2.133,2.133,0,0,1-1.572-.672A2.2,2.2,0,0,1,1.183,11.085ZM5.828,2.579A.618.618,0,0,0,6,3.015l.455.442a.668.668,0,0,0,.442.175.516.516,0,0,0,.383-.179.606.606,0,0,0,.169-.432.513.513,0,0,0-.182-.409l-.409-.455a.617.617,0,0,0-.422-.169A.589.589,0,0,0,6,2.16.565.565,0,0,0,5.828,2.579Zm3.7,3.067a2.451,2.451,0,0,1,3.44.019,2.364,2.364,0,0,1,.718,1.741,2.569,2.569,0,0,1-.351,1.274,3.318,3.318,0,0,0-2.417-.994H10.7A4.186,4.186,0,0,0,9.532,5.646Zm1.124-3.658a.58.58,0,0,0,.162.429.555.555,0,0,0,.409.162.558.558,0,0,0,.591-.591V.572a.549.549,0,0,0-.166-.409A.582.582,0,0,0,11.228,0a.555.555,0,0,0-.572.572ZM14.483,3.58a.593.593,0,0,0,.156.429.712.712,0,0,0,.429.169.693.693,0,0,0,.409-.169l.994-.994a.641.641,0,0,0,.169-.442.565.565,0,0,0-.169-.416.557.557,0,0,0-.409-.169.523.523,0,0,0-.4.169l-1.02.994A.654.654,0,0,0,14.483,3.58Zm.552,8.2a.62.62,0,0,0,.175.435l.448.435a.523.523,0,0,0,.4.169.549.549,0,0,0,.413-.172.6.6,0,0,0,.166-.432.55.55,0,0,0-.169-.4l-.448-.448a.543.543,0,0,0-.4-.169.576.576,0,0,0-.419.169A.56.56,0,0,0,15.035,11.78Zm1.014-4.373a.518.518,0,0,0,.182.4.573.573,0,0,0,.422.169h1.416a.536.536,0,0,0,.4-.162.561.561,0,0,0,.159-.409.6.6,0,0,0-.159-.419.521.521,0,0,0-.4-.172H16.653a.587.587,0,0,0-.426.175A.563.563,0,0,0,16.049,7.407Z",
    transform: "translate(0 0)",
    fill: "#888"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 20,
    height: 20,
    transform: "translate(636 545)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaysLeft);
export default __webpack_public_path__ + "static/media/days-left.ebbf0585ac6ad607ec4ea7fc23e05a0f.svg";
export { ForwardRef as ReactComponent };